import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { RegistroAsignacionEquipoService } from 'src/app/administracion/servicios/Asignacion_Equipo/registro-asignacion-equipo.service';
import Swal from 'sweetalert2';
import { SeguimientoPendientesDTO } from './seguimiento-pendientes.dto';

@Component({
  selector: 'app-control-seguimiento-asignacion-equipos',
  templateUrl: './control-seguimiento-asignacion-equipos.component.html',
  styleUrls: ['./control-seguimiento-asignacion-equipos.component.scss'],
})
export class ControlSeguimientoAsignacionEquiposComponent implements OnInit {
  /*Tabla de empleados */
  encabezados: string[] = [
    'NOTIFICACION',
    'OPCIONES',
    'NOMBRE DEL COLABORADDOR',
    'CARGO',
    'OFICINA',
  ]; /* Encabezados genéricos */
  dataSource = new MatTableDataSource<SeguimientoPendientesDTO>(
    []
  ); /* Data de la tabla      */
  @ViewChild('paginator', { static: true })
  public paginator!: MatPaginator; /* Paginator de la tabla */

  expression = false;

  constructor(
    private readonly registroAsignacionEquipoService: RegistroAsignacionEquipoService /* Conexión con la tabla registro asignación de la base de datos */,
    private readonly router: Router
  ) {}

  ngOnInit() {
    this.llenarLista();
  }

  /* CARGA LA LISTA DE COLABORADORES PROVENIENTES DEL END POINT */
  llenarLista() {
    this.expression = true;

    /* REALIZAMOS UN LLAMADO A LOS EMPLEADOS CON PENDIENTES EN LA BASE DE DATOS */
    this.registroAsignacionEquipoService.seguimiento().subscribe(
      (lista) => {
        this.dataSource.data = lista;
        this.dataSource.paginator = this.paginator;
        this.expression = false;
      },
      (error) => {
        this.expression = false;
        Swal.fire(
          '',
          'Ocurrió un error de conexión, intentélo más tarde',
          'error'
        );
      }
    );
  }

  /* NOS REDIRIGE A LA VISTA DE DETALLE DE TODOS LOS REGISTROS Y EQUIPOS QUE TIENE EL EMPLEADO */
  clickRegistros(id_empleado: number) {
    this.router.navigate(['layout/asignacionesEquipoUsuario/' + id_empleado]);
  }

  /* FILTRA LOS EMPLEADOS POR MEDIO DE SU NOMBRE COMPLETO */
  filtroDataDource(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  /*MUESTRA UNA VENTANA CON INFORMACIÓN SOBRE LA PANTALLA EN CURSO */
  clickMasInformacion(event: any) {
    Swal.fire({
      title: 'Pendientes de responsiva',
      html:
        '<p align="justify">En la siguiente tabla se muestran a todos los colaboradores de la empresa, re' +
        'saltando con un punto rojo al inicio de su fila (ademas de estar siempre al inicio de los demas ' +
        'colaboradores) aquellos que tengan pendientes aún (requiere subir nuevamente la responsiva o sub' +
        'irla por primera vez).</p>' +
        '<p align="justify"> <b>FILTRO </b> Se cueta con una barra de búsqueda por la cual se podra filtr' +
        'ar la data de la tabla ya sea por el nombre del colaborador, su cargo o su oficina para hacer un' +
        'a búsqueda más rápida.</p>' +
        '<p align="justify"> <b>BOTÓN</b> El botón que se encuentra al princicipio de cada fila nos sirve' +
        ' para ver los pendientes, las asignaciones y los equipos que tiene esta persona.</p>',

      allowEnterKey: false,
      allowEscapeKey: false,
      allowOutsideClick: false,
      confirmButtonColor: '#d33',
      confirmButtonText: 'Cerrar',
    });
  }
}
